var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { createInstance } from "@pns-fe/monitor";
import { TEA_EVENT_NAME_MAPPING } from "../../constants/cujEvents";
import { SDK_BID, VERSION } from "../../constants/env";
import { createSlardarClientAndInit } from "../../utils/SlardarUtil";
import { createTeaAndInit } from "../../utils/TeaUtil";
class MonitorModule {
  constructor() {
    this._name = `${SDK_BID}_${VERSION}_${Date.now()}`;
    this._trackingModule = createInstance(this._name);
    this._tea = null;
    this._slardar = null;
    this.init = (config) => {
      this._tea = createTeaAndInit(config);
      this._slardar = createSlardarClientAndInit(config);
      if (this._slardar) {
        this._trackingModule.init({
          slardarContainer: this._slardar,
          shouldReportJSError: {
            cuj: true
          },
          shouldRegisterUserDrop: false
        });
      }
    };
    this.reportCUJ = (name, status, data) => {
      if (!name) {
        return;
      }
      try {
        this._trackingModule.reportCUJ(name, status, data);
        if (this._tea) {
          this._tea.event(TEA_EVENT_NAME_MAPPING[name], __spreadValues({
            status
          }, data != null ? data : {}));
        }
      } catch (e) {
      }
    };
  }
}
var MonitorModule_default = MonitorModule;
export {
  MonitorModule_default as default
};
